const MediaProcessStatusEnum = {
    PENDING: 'Pending',
    UPLOADED: 'Uploaded',
    PROCESSED: 'Processed',
    INVALID: 'Invalid'
}

export default MediaProcessStatusEnum;